import { TComment } from "src/components/common/comments-area/comment/comment.types";
/**
 * This function generates a new page for the infiniteQuery cache.
 * It's necessary because when a user creates a root-level comment, the comment doesn't exist in the replies cache yet.
 */
export const createNewPageBasedOnRootComment = ({ comments, newComment }: { comments: TComment[] | undefined; newComment: TComment }) => {
    const newCommentThatHasToBeAPage = comments?.find(comment => comment.commentId === newComment.rootCommentId);

    if (newCommentThatHasToBeAPage) {
        return {
            pages: [
                {
                    comments: [{ ...newComment, replies: { replies: [newComment], repliesCount: 1 } }],
                    commentsCount: 1,
                },
            ],
            pageParams: [undefined],
        };
    }
};
